var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgLoginMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 201,
    viewBox: "0 0 257 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.26008,
    cy: 3.2552,
    rx: 3.26008,
    ry: 3.2552,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 220.511 177.52)",
    fill: "#2F7DBF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.52016,
    cy: 6.51041,
    rx: 6.52016,
    ry: 6.51041,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 13.0225 56.4648)",
    fill: "#2F7DBF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.28206,
    cy: 2.27864,
    rx: 2.28206,
    ry: 2.27864,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 202.474 52.5518)",
    fill: "#2F7DBF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.63004,
    cy: 1.6276,
    rx: 1.63004,
    ry: 1.6276,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 100.911 94.9351)",
    fill: "#2F7DBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.948 66.2436C213.948 55.313 222.797 46.4432 233.724 46.4432C244.651 46.4432 253.5 55.313 253.5 66.2435C253.5 77.1741 244.651 86.0439 233.724 86.0439C222.797 86.0439 213.948 77.1741 213.948 66.2436Z",
    stroke: "#2F7DBF",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 185.78C12.5 179.002 17.988 173.5 24.7656 173.5C31.5433 173.5 37.0312 179.002 37.0312 185.78C37.0312 192.559 31.5433 198.061 24.7656 198.061C17.988 198.061 12.5 192.559 12.5 185.78Z",
    stroke: "#2F7DBF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9248 7.89015C77.9248 4.36311 80.7804 1.50004 84.3076 1.50004C87.8349 1.50004 90.6904 4.36311 90.6904 7.89015C90.6904 11.4172 87.8349 14.2803 84.3076 14.2803C80.7804 14.2803 77.9248 11.4172 77.9248 7.89015Z",
    stroke: "#2F7DBF",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLoginMobile);
export default __webpack_public_path__ + "static/media/bgLoginMobile.7a7d6a32cef203b2c86bfb46ca66d07e.svg";
export { ForwardRef as ReactComponent };